import React from "react";

function Skelton() {
  return (
    <div className=" w-full lg:w-[14rem] lg:min-w-[14rem] ">
      <div className="relative flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full bg-white border-2 border-secondary animate-pulse animate-delay-700 rounded-2xl  h-[8rem] lg:w-auto lg:h-72 min-w-full lg:text-2xl">
        <p className="  lg:h-2/4 h-24 w-[70%] max-w-[108px] bg-gray-200 rounded-lg animate-pulse  lg:max-w-full mt-2 "></p>
        <div className="w-[40%] lg:w-full flex justify-center items-center flex-col ">
          <p className="  h-4 w-full lg:w-[50%] bg-gray-200 rounded-lg animate-pulse  lg:max-w-full mt-2 "></p>
          <p className="  h-4 w-full lg:w-[40%] bg-gray-200 rounded-lg animate-pulse  lg:max-w-full mt-2 "></p>
        </div>
      </div>
    </div>
  );
}

export default Skelton;
